import QuestionConfig from "./QuestionConfig";
import BaseContent from "../utils/BaseContent";
import { Subject, Observable } from "rxjs";

export default abstract class BaseQuestion extends BaseContent {
  protected questionEventSubject: Subject<any> = new Subject<any>();
  constructor(public config: QuestionConfig) {
    super();
  }
  protected get observable(): Observable<any> {
    return this.questionEventSubject.asObservable();
  }
}
